import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import AboutHero from './components/AboutHero';
import AboutIntro from './components/AboutIntro';
import Advantages from './components/Advantages';
import AboutReviews from './components/AboutReviews';
import ContactCTA from './components/ContactCTA';
import { buildWebPageSchema, buildBreadcrumbSchema } from '@/mocks/schema';

const webPageSchema = buildWebPageSchema({
  title: '关于我们 - 51吃瓜每日大赛',
  description: '了解51吃瓜每日大赛的品牌故事、核心优势与团队理念。全网最真实、最及时的娱乐爆料平台，坚持免费浏览，做最懂你的吃瓜平台。',
  url: 'http://dingzhishi.cn/about',
  dateModified: '2026-07-07',
});

const breadcrumbSchema = buildBreadcrumbSchema([
  { name: '首页', url: 'http://dingzhishi.cn/' },
  { name: '关于我们', url: 'http://dingzhishi.cn/about' },
]);

export default function AboutPage() {
  return (
    <>
      <SchemaOrg data={webPageSchema} />
      <SchemaOrg data={breadcrumbSchema} />
      <Navbar />
      <main>
        <nav className="w-full px-4 md:px-8 pt-20" aria-label="Breadcrumb">
          <div className="max-w-[1280px] mx-auto flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </span>
            <span className="text-foreground-700 whitespace-nowrap">关于我们</span>
          </div>
        </nav>
        <AboutHero />
        <AboutIntro />
        <Advantages />
        <AboutReviews />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
}